// src/redux/registerFormReducer.ts
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ForgotPasswordFormState {
    loading: boolean
    successMessage?: string
    errorMessage?: string
}

export interface ForgotPasswordFormData {
    EmailAddress?: string
}

export interface ForgotPasswordResponse {
    data: any
}
const initialState: any = {
    forgotPasswordData: null,
};

const forgotPasswordSlice = createSlice({
    name: 'forgotPassword',
    initialState,
    reducers: {
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setSuccessMessage: (state, action: PayloadAction<string | undefined>) => {
            state.successMessage = action.payload;
        },
        setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.errorMessage = action.payload;
        },
    },
});

export const forgotPasswordFormAPI = createApi({
    reducerPath: 'forgotpassword', //our reducer lives at store.reducer
    tagTypes: ['RegistrationFormData'],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3'), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<ForgotPasswordResponse, Partial<ForgotPasswordFormData>>({
            query: (body) => ({
                url: '/page/forgotpassword',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export default forgotPasswordSlice.reducer;
export const { useSubmitFormMutation } = forgotPasswordFormAPI
